export const APP_NAME = "Akhirah Projects · Prayer";
export const BRAND_TAGLINE = "Prayer times, Hijri calendar, Ramadan timetable, and key Islamic dates.";

export const DEFAULT_SETTINGS = {
  methodId: 3, // MWL in AlAdhan list
  calculationMethodMode: "auto",
  madhhab: "shafi",
  hijriAdjustment: 0,
  hijriAdjustmentMode: "auto",
  timeFormat: "24h",
  fardBuffers: { fajr: 15, asr: 15 }
} as const;

export const CALC_METHODS: Array<{ id: number; label: string }> = [
  { id: 0, label: "Shia Ithna-Ashari (Leva Institute, Qum)" },
  { id: 1, label: "University of Islamic Sciences, Karachi" },
  { id: 2, label: "Islamic Society of North America (ISNA)" },
  { id: 3, label: "Muslim World League (MWL)" },
  { id: 4, label: "Umm al-Qura, Makkah" },
  { id: 5, label: "Egyptian General Authority of Survey" },
  { id: 7, label: "Institute of Geophysics, University of Tehran" },
  { id: 8, label: "Gulf Region" },
  { id: 9, label: "Kuwait" },
  { id: 10, label: "Qatar" },
  { id: 11, label: "Majlis Ugama Islam Singapura, Singapore" },
  { id: 12, label: "Union Organization Islamic de France" },
  { id: 13, label: "Diyanet İşleri Başkanlığı, Turkey" },
  { id: 14, label: "Spiritual Administration of Muslims of Russia" }
];

export const CALC_METHOD_BY_COUNTRY: Record<string, { id: number; label: string }> = {
  Pakistan: { id: 1, label: "University of Islamic Sciences, Karachi" },
  India: { id: 1, label: "University of Islamic Sciences, Karachi" },
  Bangladesh: { id: 1, label: "University of Islamic Sciences, Karachi" },
  Afghanistan: { id: 1, label: "University of Islamic Sciences, Karachi" },
  USA: { id: 2, label: "Islamic Society of North America (ISNA)" },
  Canada: { id: 2, label: "Islamic Society of North America (ISNA)" },
  "United Kingdom": { id: 3, label: "Muslim World League (MWL)" },
  Germany: { id: 3, label: "Muslim World League (MWL)" },
  Spain: { id: 3, label: "Muslim World League (MWL)" },
  Italy: { id: 3, label: "Muslim World League (MWL)" },
  Netherlands: { id: 3, label: "Muslim World League (MWL)" },
  Belgium: { id: 3, label: "Muslim World League (MWL)" },
  Sweden: { id: 3, label: "Muslim World League (MWL)" },
  Norway: { id: 3, label: "Muslim World League (MWL)" },
  France: { id: 12, label: "Union Organization Islamic de France" },
  "Saudi Arabia": { id: 4, label: "Umm al-Qura, Makkah" },
  Egypt: { id: 5, label: "Egyptian General Authority of Survey" },
  Iran: { id: 7, label: "Institute of Geophysics, University of Tehran" },
  UAE: { id: 8, label: "Gulf Region" },
  Qatar: { id: 10, label: "Qatar" },
  Kuwait: { id: 9, label: "Kuwait" },
  Bahrain: { id: 8, label: "Gulf Region" },
  Oman: { id: 8, label: "Gulf Region" },
  Turkey: { id: 13, label: "Diyanet Isleri Baskanligi, Turkey" },
  Singapore: { id: 11, label: "Majlis Ugama Islam Singapura, Singapore" },
  Australia: { id: 3, label: "Muslim World League (MWL)" }
};
